import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface IFeedback {
  message: string;
}

export interface IRecoverPassword {
  email: string;
}

export const serviceApi = createApi({
  reducerPath: 'serviceApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    sendFeedback: builder.mutation<void, IFeedback>({
      query: (feedback) => ({
        url: `/feedback`,
        method: 'POST',
        body: feedback,
      }),
    }),
    resendVerificationKey: builder.mutation<void, { returnUrl?: string }>({
      query: (data) => ({
        url: `/users/resend_verification_key`,
        method: 'POST',
        body: data
      }),
    }),
    recoverPassword: builder.mutation<void, IRecoverPassword>({
      query: (data) => ({
        url: `/auth/recover`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useSendFeedbackMutation, useResendVerificationKeyMutation, useRecoverPasswordMutation } = serviceApi;
